export default __webpack_public_path__ + "static/media/upload-1.23323955.svg";